<template>
  <section>
    <div class="container" v-if="professional">

      <div class="row" style="margin-top: 15px;">
        <div class="col-12 col-md-4">
          <h3>{{ professional ? professional.name: '' }}</h3>
        </div>
      </div>

      <div class="row">
        <div class="col-12">

          <form @submit.prevent="submitPostAddress">
            <div class="form-group">
              <label for="post_addres">กรุณากรอกที่อยู่สำหรับจัดส่งของคุณ</label>
              <textarea type="text" class="form-control" rows="5"
                        id="post_addres" required
                        v-model="postAddress"></textarea>
            </div>
            <div class="form-group">
              <button type="submit" :disabled="loading"
                      class="btn btn-success">บันทึก
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'ProfessionalPostAddress',
    data () {
      return {
        professional: null,
        postAddress: '',
        loading: false
      }
    },
    methods: {
      async getProfessionalInfo () {
        let { data } = await axios.get('professionals/' + this.$route.params.id)
        this.professional = data.professional
        this.postAddress = data.professional.post_address
      },
      async submitPostAddress () {
        this.loading = true
        let { data } = await axios.put('professionals/' + this.$route.params.id + '/post-address', {
          post_address: this.postAddress
        })
        this.$swal({
          type: 'success',
          text: 'บันทึกสำเร็จ'
        })
        this.postAddress = data.professional.post_address
        this.loading = false
      },
      async checkValidation () {
        let { data } = await axios.post('professionals/' + this.$route.params.id + '/check-validation', {
          professional_id: this.$route.query.validation
        })
        if (!data.error) {
          this.getProfessionalInfo()
        } else {
          this.$swal({
            type: 'error',
            text: 'การเข้ารหัสไม่ถูกต้อง'
          })
        }
      }
    },
    created () {
      this.checkValidation()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/professional/ProfessionalPostAddress.vue